import { render } from "./EditAgent.vue?vue&type=template&id=39c1b578&scoped=true"
import script from "./EditAgent.vue?vue&type=script&lang=js"
export * from "./EditAgent.vue?vue&type=script&lang=js"

import "./EditAgent.vue?vue&type=style&index=0&id=39c1b578&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-39c1b578"

export default script